import { Box, Divider } from "@mui/material";
import { MRTGrid } from "@foodpilot/foods";
import { Document } from "src/api/client-api/documentation/types";
import { DocumentationListGridHeader } from "./DocumentationListGridHeader";
import { DocumentationListGridEmpty } from "./DocumentationListGridEmpty";
import { useDocumentListContext } from "../DocumentationContext";
import { columns } from "./DocumentationListGridColumns/DocumentationListGridColumns";
import { styles } from "./styles/DocumentationListGrid";
import { useFoodpilotContext, VIEW, DELETE, MEDIA_CONTENT } from "src/context/FoodpilotContext.tsx";

interface DocumentationListGridProps {
    documents: Document[];
    isLoading?: boolean;
}

export const DocumentationListGrid = (props: DocumentationListGridProps) => {
    const { documents } = props;
    const { page, setPage, sorting, setSorting, search, isLoading, totalItems } = useDocumentListContext();
    const { canUser } = useFoodpilotContext();
    const canView = canUser(VIEW, MEDIA_CONTENT);
    const canDelete = canUser(DELETE, MEDIA_CONTENT);

    if (!totalItems && !isLoading) {
        return (
            <>
                <DocumentationListGridHeader />
                <Divider />
                <Box sx={styles.emptyContainer}>
                    <DocumentationListGridEmpty emptyResults={!!search} />
                </Box>
            </>
        );
    }
    return (
        <>
            <DocumentationListGridHeader />
            <MRTGrid
                columns={columns({ canView, canDelete })}
                data={documents}
                state={{
                    isLoading,
                    pagination: page,
                    sorting,
                }}
                manualPagination
                manualSorting
                onPaginationChange={setPage}
                onSortingChange={setSorting}
                enableStickyHeader={true}
                enableTopToolbar={true}
                enableBottomToolbar={true}
                enableColumnResizing={false}
                enablePagination={true}
                enableSorting={true}
                enableMultiSort={false}
                enableRowSelection={false}
                enableRowActions={false}
                enableToolbarInternalActions={false}
                enableColumnActions={false}
                rowCount={totalItems}
            />
        </>
    );
};
